import React from "react";
import Footer from "../pages/Website/Footer";
import ContactNavbarWebsite from "./Navbar/ContactNavbarWebsite";

const Contact = () => {
  return (
    <div>
      <ContactNavbarWebsite />
      <div>
        <section className="bg-white ">
          <div className="max-w-screen-md px-4 py-8 mx-auto lg:py-16">
            <h2 className="mb-4 font-medium tracking-tight text-center text-black lg:text-3xl">
              Contact Us
            </h2>
            <p className="mb-8 font-light text-center text-black lg:mb-16 sm:text-xl">
              Got a technical issue? Want to send feedback about a beta feature?
              Need details about our Business plan? Let us know.
            </p>
            <div className="flex flex-col justify-start gap-y-6">
            <div className="flex flex-col justify-start py-2 text-xl font-medium text-black border-b border-gray-500 gap-y-2">
              <div>Name: Dhaval Shah</div>
              Number: +91-9619818332
            </div>
            <div className="flex flex-col justify-start text-xl font-medium text-black border-b border-gray-500 gap-y-2py-2">
              <div>Name: Chirag Shah</div>
              Number: +91-9619408885
            </div>
            <div className="flex flex-col justify-start text-xl font-medium text-black border-b border-gray-500 gap-y-2py-2">
              <div>Address:</div>
              25/26, Lohana Bhuvan, Pali ram road, behind BMC office,
              Andheri(w), Mumbai-400058
            </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
